import { PaginationControls } from '@common/types/pagination';
import { CaretLeftIcon, CaretRightIcon } from '@radix-ui/react-icons';
import { Box, IconButton } from '@radix-ui/themes';

import classNames from 'classnames';
import styles from './AvenuePaginationControl.module.css';

type AvenuePaginationControlProps = PaginationControls;

export const AvenuePaginationControl = ({
    hasPreviousPage,
    hasNextPage,

    previousPage,
    nextPage,
}: AvenuePaginationControlProps) => {
    return (
        <Box>
            {hasPreviousPage && (
                <IconButton
                    color={'gray'}
                    highContrast
                    variant={'soft'}
                    onClick={previousPage}
                    aria-label='Previous page'
                    disabled={!hasPreviousPage}
                    className={classNames(styles.navButton, styles.previous)}
                >
                    <CaretLeftIcon width={24} height={24} />
                </IconButton>
            )}

            {hasNextPage && (
                <IconButton
                    color={'gray'}
                    highContrast
                    variant={'soft'}
                    onClick={nextPage}
                    aria-label='Next page'
                    disabled={!hasNextPage}
                    className={classNames(styles.navButton, styles.next)}
                >
                    <CaretRightIcon width={24} height={24} />
                </IconButton>
            )}
        </Box>
    );
};
